import Column from './Column.vue';
import Columns from './Columns.vue';
import Container from './Container.vue';
import ControlGroup from './ControlGroup.vue';
import PageHeader from './PageHeader.vue';
import PageTitle from './PageTitle.vue';
import PageTitleDropdown from './PageTitleDropdown.ts.vue';
import PageTitleNavigation from './PageTitleNavigation.vue';
import PageWrapper from './PageWrapper.vue';
import Sidebar from './Sidebar.ts.vue';

export default [
  Column,
  Columns,
  Container,
  ControlGroup,
  PageHeader,
  PageTitle,
  PageTitleDropdown,
  PageTitleNavigation,
  PageWrapper,
  Sidebar,
];
